export const DeliveryExtras = {
    check: 'check',
    test: 'test'
}